import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  GetEmployeeTasksApiResponse,
  TaskTypeEnum,
} from 'abi-lcm-common-types';

import { lcmApi } from '~/shared/services/api';

import { GET_TASKS_QUERY_KEY } from './queryKeys';

type ChangeTaskCompletionPayload = {
  taskType: TaskTypeEnum;
  newCompletion: boolean;
};

const updateTasks = (
  task: ChangeTaskCompletionPayload,
  old?: GetEmployeeTasksApiResponse
) => {
  if (!old) return old;

  return old.map(oldTask => {
    return oldTask.taskType === task.taskType
      ? { ...oldTask, isCompleted: task.newCompletion }
      : oldTask;
  });
};

async function changeTaskCompletion(
  payload: ChangeTaskCompletionPayload
): Promise<void> {
  const { data } = await lcmApi.patch(
    '/task-completion/change-completion',
    payload
  );

  return data;
}

export function useTaskCompletion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeTaskCompletion,
    onMutate: async payload => {
      await queryClient.cancelQueries({ queryKey: [GET_TASKS_QUERY_KEY] });

      const previous = queryClient.getQueryData([GET_TASKS_QUERY_KEY]);

      queryClient.setQueryData<GetEmployeeTasksApiResponse>(
        [GET_TASKS_QUERY_KEY],
        old => updateTasks(payload, old)
      );

      return { optimistic: payload, previous };
    },
    onError: async (_error, _payload, context) => {
      queryClient.setQueryData([GET_TASKS_QUERY_KEY], context?.previous);
    },
  });
}
